import { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PageLoading } from '@ant-design/pro-layout';
import { Layout } from '@/components';
import rutasPublicas from './routes/rutasPublicas';
import rutasPrivadas from './routes/rutasPrivadas';
import NotFound from './pages/NotFound';
import { useRecoilValue } from 'recoil';
import { loginInfo } from './state';

const RootRouter = () => {
  const infoLogin = useRecoilValue(loginInfo);

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          {rutasPublicas.map((route, index: number) => (
            <Route
              key={index}
              {...route}
              element={
                !infoLogin.login ? (
                  <Suspense fallback={<PageLoading />}>
                    {route.element}
                  </Suspense>
                ) : (
                  <Navigate to="/Estancias" replace={true} />
                )
              }
            />
          ))}
          {rutasPrivadas.map((route, index: number) => (
            <Route
              key={index}
              {...route}
              element={
                infoLogin.login ? (
                  <Suspense fallback={<PageLoading />}>
                    {route.element}
                  </Suspense>
                ) : (
                  <Navigate to="/" replace={true} />
                )
              }
            />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
};

export default RootRouter;
